module.exports = __webpack_public_path__ + "img/developing-our-plan.0488fd7f.jpg";